import { GridColumnVisibilityModel } from '@mui/x-data-grid-pro'
import React from 'react'
import { APIKeyResponse } from 'src/queries/organizations/apikeys.queries'

import APIKeyDataGrid from './APIKeyDataGrid'

interface APIKeysTableProps {
  apiKeys: APIKeyResponse[]
}

const APIKeysTable: React.FC<APIKeysTableProps> = (props) => {
  const defaultColumnVisibilityModel: GridColumnVisibilityModel = {
    apiKeyId: true,
    apiSecretKey: true,
    expiry: true,
  }

  return (
    <APIKeyDataGrid
      apiKeys={props.apiKeys}
      defaultColumnVisibilityModel={defaultColumnVisibilityModel}
    />
  )
}

export default APIKeysTable
